import { toast } from 'react-toastify';

// Pages like the client Overview fire several independent data fetches on
// mount (cycles, contracts, screens, counts, ...). When they all fail for
// the same underlying reason - most commonly a 403 for a client the user
// isn't assigned to - each one's own catch block toasts the same message,
// stacking up to one toast per request. Keying the toast's id by its own
// text means react-toastify collapses repeats of the same message into a
// single visible toast, while distinct error messages still show separately.
export const toastErrorDeduped = (message: string) => {
  toast.error(message, { toastId: message });
};
